// extracted by mini-css-extract-plugin
export default {"intro-message":"ChannelInvites_intro-message__5hbGN","intro-url":"ChannelInvites_intro-url__zsfA8","popover-message":"ChannelInvites_popover-message__L6tlf"};